import Axios from "axios";

export class ProveedorService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/proveedor/lista?${queryParams}`).then(res => res.data);
    }

    newProveedor(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/proveedor/nuevo`, data).then(res => res.data);
    }

    editarProveedor(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/proveedor/editar`, data).then(res => res.data);
    }

    eliminarProveedor(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/proveedor/eliminar/${id}`).then(res => res.data);
    }

    consultarProveedor(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/proveedor/consulta/${id}`, { params: opciones }).then(res => res.data);
    }

    descargar(id, firmar, estado, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/proveedor/reporte/${id}/${firmar}/${estado}`,
            { headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob', params: opciones }).then(async res => res.data);
    }
}
